// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"67c47d09","453":"e9487b61","667":"c5c1ea6e","977":"5de22fe6"}[chunkId] + ".chunk.js";
};